import React, { useState, useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import { useLanguage } from "../utils/LanguageContext";
import ReactMarkdown from "react-markdown";
import gfm from "remark-gfm";
import "github-markdown-css/github-markdown-light.css";

import ChartBlock from "./ChartBlock";

function Markdown() {
  const { doc } = useParams();
  const location = useLocation();
  const { language } = useLanguage();
  const [markdown, setMarkdown] = useState("");

  useEffect(() => {
    const isIndicateurRoute = location.pathname.startsWith("/indicateur");
    const sourcePath = isIndicateurRoute
      ? `/indicateur/text/${language}/${doc}`
      : `/docu/${language}/${doc}`;

    fetch(sourcePath)
      .then((response) => response.text())
      .then(setMarkdown)
      .catch((error) => {
        console.error(`Erreur chargement Markdown ${sourcePath}:`, error);
        setMarkdown("");
      });
  }, [doc, location.pathname, language]);

  const detectchart = {
    p({ children }) {
      if (
        Array.isArray(children) &&
        typeof children[0] === "string" &&
        children[0].startsWith("[[")
      ) {
        const text = children[0];

        // Détecte [[type:chartId]]
        const chartMatch = text.match(/\[\[(\w+):(.+?)\]\]/);

        if (chartMatch) {
          const [, chartType, chartId] = chartMatch;
          return <ChartBlock type={chartType} chartdata={chartId} />;
        }
      }

      return <p>{children}</p>;
    },
  };

  return (
    <div className="flex-grow p-4">
      <div className="w-full max-w-screen-xl mx-auto">
        <div className="markdown-body" style={{ backgroundColor: "#f8fafc" }}>
          <ReactMarkdown
            className="font-sans text-lg"
            remarkPlugins={[gfm]}
            components={detectchart}
          >
            {markdown}
          </ReactMarkdown>
        </div>
      </div>
    </div>
  );
}

export default Markdown;
